import React, { useState } from "react";
import { useParams, useSearchParams  } from "react-router-dom";
import "../../css/RegistrationForm.css";
import api from "../../services/api";

const StepOne = ({ onNext }) => {
  const { code } = useParams();
  const [email, setEmail] = useState("");
  const [phone, setPhoneNumber] = useState("");
  const [participants, setParticipants] = useState(1);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const handleEmailChange = (e) => setEmail(e.target.value);

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    if (/^(\+)?[0-9 ]*$/.test(value)) {
      setPhoneNumber(value);
    }
  };

  const handleParticipantsChange = (delta) => {
    setParticipants((prev) => Math.max(1, Math.min(5, prev + delta)));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    const preReservation = {
      email,
      phone,
      participants,
    };

    try {
      const response = await api.makePrereservation(code, preReservation, searchParams);
      if (response) {
        onNext({ email, phone, participants, guid: response.guid, config: response.config });
      } else {
        setError("Nie udało się utworzyć rezerwacji. Spróbuj ponownie.");
      }
    } catch (err) {
      setError( err?.response?.data?.message || "Wystąpił błąd podczas tworzenia rezerwacji. Spróbuj ponownie.");
    } finally {
      setIsLoading(false); 
    }
  };

  return (
    <div className="registration-form-container">
      <h2>Formularz Rejestracyjny</h2>
      <p>
        Na początek wskaż ile osób chcesz zapisać na wydarzenie i podaj podstawowe dane kontaktowe.
      </p>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Wprowadź swój e-mail"
            required
            disabled={isLoading} 
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Numer telefonu *</label>
          <input
            type="tel"
            id="phone"
            value={phone}
            onChange={handlePhoneNumberChange}
            placeholder="123456789"
            required
            disabled={isLoading}
            pattern="^\+?[0-9 ]{9,15}$"
            title="Podaj poprawny numer telefonu (9-15 cyfr, opcjonalnie z +)"
          />
        </div>
        <div className="form-group">
          <label>Liczba osób uczestniczących</label>
          <div className="participants-control">
            <button
              type="button"
              onClick={() => handleParticipantsChange(-1)}
              disabled={participants <= 1 || isLoading}
            >
              -
            </button>
            <span>{participants}</span>
            <button
              type="button"
              onClick={() => handleParticipantsChange(1)}
              disabled={participants >= 5 || isLoading}
            >
              +
            </button>
          </div>
        </div>
        <div className="form-buttons">
          <button type="submit" className="submit-button" disabled={isLoading}>
            {isLoading ? (
              <span className="loading-content">
              <div className="spinner"></div> Przetwarzanie...
            </span>
            ) : (
              "Zatwierdź"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StepOne;
